import { useEffect } from 'react';
import { presenceService } from '../services/presenceService';

const HEARTBEAT_MS = 60_000;

/** Keeps profiles.last_seen_at fresh while the user has the app open. */
export function usePresenceHeartbeat(userId: string | undefined | null) {
  useEffect(() => {
    if (!userId) return;

    const tick = async () => {
      const res = await presenceService.heartbeat();
      if (res.ok) {
        window.dispatchEvent(new CustomEvent('d88-presence-heartbeat'));
      }
    };

    tick();
    const interval = window.setInterval(tick, HEARTBEAT_MS);

    const onVisibility = () => {
      if (document.visibilityState === 'visible') tick();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [userId]);
}
